<template>
<form>
    <div class="form-row pl-2 text-muted">
        <h5>Monatsberichte</h5>
    </div>
    <div class="row">
        <div class="col-sm-2" style="margin-bottom: 5px">
            <select
                v-model="t_currentYear"
                class="custom-select"
                title="Jahr für Monatsberichte"
                id="currentYearSelection">
                <!--<option value=0 selected>Gruppe auswählen...</option>-->
                <option v-for="item_name in t_years" :key="item_name" :value="item_name">
                    {{ item_name }}
                </option>
            </select>
        </div>
    </div>
    <div class="container">

        <div class="row">
            <div class="col-9">
                <a v-on:click="performAutoReport(t_currentYear, '00')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender-year btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    {{ this.t_currentYear }} - Gesamtjahr
                </a>
            </div>
            <div class="col-3"><!-- Quartal? -->&nbsp; </div>
        </div>
        
        <div class="row">
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '01')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    Januar
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '02')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    Februar
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '03')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    März
                </a>
            </div>
            <div class="col"><!-- Quartal? --></div>
        </div>
        <div class="row">
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '04')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    April
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '05')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    Mai
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '06')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    Juni
                </a>
            </div>
            <div class="col"><!-- Quartal? --></div>
        </div>
        <div class="row">
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '07')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    Juli
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '08')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    August
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '09')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    September
                </a>
            </div>
            <div class="col"><!-- Quartal? --></div>
        </div>
        <div class="row">
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '10')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    Oktober
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '11')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    November
                </a>
            </div>
            <div class="col">
                <a v-on:click="performAutoReport(t_currentYear, '12')"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-primary btn-calender btn-sm mx-auto"
                        href="#"
                        role="button"
                        id="createReport">
                    Dezember
                </a>
            </div>
            <div class="col"><!-- Quartal? --></div>
        </div>
    </div>
    <p></p>
    <div class="form-row pl-2 text-muted">
        <h5>Benutzerdefinierten Bericht erzeugen</h5>
    </div>
    <div class="form-row pl-2 pr-5">
        <div class="col-3 pl-0">
            <label for="fromDate" title="Beginn des Berichtszeitraums">Beginn des Berichtszeitraums</label>
            <datepicker
                format="yyyy-MM-dd"
                v-model="t_fromDate"
                input-class="form-control"
                :language="de"
                :monday-first=true
                id="fromDate"
                :disabled-dates="{from: new Date()}"
                @keydown.enter.prevent
            >
            </datepicker> 
        </div>
        <div class="col-3">
            <label for="toDate" title="Ende des Berichtszeitraums">Ende des Berichtszeitraums</label>
            <datepicker
                format="yyyy-MM-dd"
                v-model="t_toDate"
                input-class="form-control"
                :language="de"
                :monday-first=true
                id="toDate"
                :disabled-dates="{from: new Date()}"
                @keydown.enter.prevent
            >
            </datepicker> 
        </div>
        <div class="col">
            <label for="filename">Dateiname</label>
            <input v-model="t_filename" type="text"
                    class="form-control" id="filename" placeholder="Dateiname">
        </div>
        <div class="col-1">
            <label for="createReport">&nbsp;</label>
            <div class="p-0">
                <a v-on:click="perform()"
                        v-on:submit.prevent="onSubmit"
                        class="btn btn-success"
                        href="#"
                        role="button"
                        id="createReport">
                    Bericht erzeugen
                </a>
            </div>
        </div>
    </div>
    <hr>
    <div class="form-row pl-2 text-muted">
        <h5>Berichte</h5>
    </div>
    <div class="row pl-2">
        <div class="col pl-2">
        <table class="table table-sm table-hover table-bordered"
                style="max-height: 100%; overflow: auto;" id="reports">
            <thead class="thead-light">
                <tr>
                    <!--<th>#</th>-->
                    <th>Erstellt am</th>
                    <th>Dateiname</th>
                    <th class="fit"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="!this.reports.length">
                    <td colspan="3"><span style="text-align: center;">Keine Berichte verfügbar</span></td>
                </tr>
                <tr v-for="report in this.reports" v-bind:key="report.filename">
                    <td>{{ $filters.formatDateTime(report.last_modified) }}</td>
                    <td>{{ report.filename }}</td>
                    <td style="width: 1%; white-space: nowrap;">
                        <div class="d-flex align-items-end flex-column">
                                <a
                                    href="#"
                                    @click="downloadDocument(report.filename)"
                                    title="Bericht runterladen"
                                >
                                    <i class="far fa-file fa-fw fa-lg text-secondary"></i>
                                </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</form>
</template>

<script>
import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale'

const api_url = process.env.VUE_APP_ROOT_API;

export default {
    name: 'Reports',
    components: {
        Datepicker
    },
    data() {
        return {
            defaultReports: [],
            t_filename: '',
            t_fromDate: '',
            t_toDate: '',
            t_currentYear: '2021',
            en: en,
            de: de,
            t_years: ['2021', '2020']
        }
    },
    computed: {
        accountName () {
            if (this.$store.state.account_info) {
                return this.$store.state.current_acc
            } else {
                return null
            }
        },
        reports() {
            if (this.$store.state.account_info) {
                return this.$store.state.reports
            } else {
                return this.defaultReports
            }
        }
    },
    methods: {
        downloadDocument(filename) {
            let credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: api_url + "/reports/" + this.accountName + "/" + filename,
                method: 'GET',
                responseType: 'blob',
                auth: credentials
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                let displayedFilename = filename
                    .replace("HIDDEN_MONTHLY_REPORT", "Monatsreport")
                    .replace("HIDDEN_YEARLY_REPORT", "Jahresreport");
                link.setAttribute('download', displayedFilename);
                document.body.appendChild(link);
                link.click();
            });
        },
        perform() {
            if (this.t_fromDate == '' || this.t_toDate == '') {
                this.$store.commit('add_message',
                    {type: "ERROR", message: "Datumsfelder dürfen nicht leer sein."})
                return;
            }
            if (this.t_filename == '') {
                this.$store.commit('add_message',
                    {type: "ERROR", message: "Dateiname darf nicht leer sein."})
                return;
            }
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            const data = new FormData();
            data.append('fromDate', this.$filters.formatDate(this.t_fromDate))
            data.append('toDate', this.$filters.formatDate(this.t_toDate))
            var msg = {type: "NONE"}
            axios({
                url: process.env.VUE_APP_ROOT_API
                    + '/reports/'
                    + this.accountName + '/'
                    + this.t_filename,
                data: data,
                auth: credentials,
                method: 'post'
            })
            .catch(e => {
                // eslint-disable-next-line
                console.log("Error in posting report");
                // eslint-disable-next-line
                console.log(e);
                this.$store.commit('add_message', {type: "ERROR", message: "Fehler"})
            })
            .then(resp => {
                msg = resp.data
                if (!(msg.type == "NONE")) {
                    this.$store.commit('add_message', msg)
                }
                this.t_toDate = '';
                this.t_fromDate = '';
                this.t_filename = '';
            });
            this.$store.dispatch('loadReports')
        },
        performAutoReport(year, month) {
            let credentials = JSON.parse(localStorage.getItem('credentials'))
            const data = new FormData();
            data.append('month', month)
            data.append('year', year)
            let hiddenFileName = "HIDDEN_MONTHLY_REPORT_" + year + "-" + month;
            if (month === '00') {
                hiddenFileName = "HIDDEN_YEARLY_REPORT_" + year;
            }
            let msg = {type: "NONE"}
            axios({
                url: process.env.VUE_APP_ROOT_API
                    + '/reports/'
                    + this.accountName + '/'
                    + hiddenFileName,
                data: data,
                auth: credentials,
                method: 'post'
            })
            .catch(e => {
                // eslint-disable-next-line
                console.log("Error in posting report");
                // eslint-disable-next-line
                console.log(e);
                this.$store.commit('add_message', {type: "ERROR", message: "Fehler"})
            })
            .then(resp => {
                msg = resp.data;
                if (msg.type === "ERROR") {
                    this.$store.commit('add_message', msg)
                    return;
                }
                this.downloadDocument(hiddenFileName + ".odt");
            });
        }
    },
    beforeMount() {
        console.log('Reports component beforeMount');
        let current_year_int = new Date().getFullYear();
        this.t_currentYear = current_year_int.toString();
        this.t_years = []
        for (let year = current_year_int; year > current_year_int - 5; year--) {
            this.t_years.push(year.toString());
        }
    },
    mounted() {
        console.log('Reports component mounted');
    },
    beforeUnmount() {
        console.log('Reports component beforeDestroy');
    }
}
</script>

<style scoped>

.container {
    max-width: 70rem;
    margin-left: 1rem !important;
    margin-top: 1rem;
    margin-bottom: 2rem;
}

.btn-calender {
    width: 100% !important;
    margin: 5px 20px 5px 5px !important;
}

.btn-calender-year {
    width: 100% !important;
    margin: 5px 20px 5px 5px !important;
}
</style>